import { render, staticRenderFns } from "./TvDashboardPage.vue?vue&type=template&id=95e9c34e&"
import script from "./TvDashboardPage.vue?vue&type=script&lang=js&"
export * from "./TvDashboardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports